// extracted by mini-css-extract-plugin
export default {"cls1":"Cta-cls1_PIn","cls2":"Cta-cls2__Rs Cta-cls1_PIn"};